import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      class="theme-toggle"
      (click)="themeService.toggle()"
      [attr.aria-label]="themeService.isDark() ? 'Activer le mode jour' : 'Activer le mode nuit'"
      [attr.aria-pressed]="themeService.isDark()"
    >
      <!-- Stars (visible in dark mode) -->
      <div class="stars">
        <span class="star" style="top: 6px; left: 8px; animation-delay: 0s;"></span>
        <span class="star" style="top: 12px; left: 18px; animation-delay: 0.3s;"></span>
        <span class="star" style="top: 8px; left: 28px; animation-delay: 0.6s;"></span>
        <span class="star" style="top: 18px; left: 12px; animation-delay: 0.9s;"></span>
        <span class="star" style="top: 20px; left: 24px; animation-delay: 1.2s;"></span>
      </div>

      <!-- Sun/Moon circle -->
      <div class="theme-toggle-circle">
        <!-- Sun rays (visible in light mode) -->
        @if (!themeService.isDark()) {
          <svg class="absolute inset-0 w-full h-full" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="4" fill="#fbbf24" />
            @for (i of sunRays; track i) {
              <line
                [attr.x1]="12 + 6 * Math.cos((i * 45 * Math.PI) / 180)"
                [attr.y1]="12 + 6 * Math.sin((i * 45 * Math.PI) / 180)"
                [attr.x2]="12 + 9 * Math.cos((i * 45 * Math.PI) / 180)"
                [attr.y2]="12 + 9 * Math.sin((i * 45 * Math.PI) / 180)"
                stroke="#fbbf24"
                stroke-width="2"
                stroke-linecap="round"
              />
            }
          </svg>
        } @else {
          <svg class="absolute inset-0 w-full h-full" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="#c7d2fe" />
            <circle cx="8" cy="10" r="2" fill="#a5b4fc" opacity="0.6" />
            <circle cx="14" cy="14" r="1.5" fill="#a5b4fc" opacity="0.4" />
            <circle cx="10" cy="16" r="1" fill="#a5b4fc" opacity="0.5" />
          </svg>
        }
      </div>
    </button>
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }
    `,
  ],
})
export class ThemeToggleComponent {
  protected readonly themeService = inject(ThemeService);
  protected readonly Math = Math;
  protected readonly sunRays = [0, 1, 2, 3, 4, 5, 6, 7];
}
